"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyListings$ = exports.PropertyListings$outboundSchema = exports.PropertyListings$inboundSchema = void 0;
exports.propertyListingsToJSON = propertyListingsToJSON;
exports.propertyListingsFromJSON = propertyListingsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rentallisting_js_1 = require("./rentallisting.js");
const salelisting_js_1 = require("./salelisting.js");
/** @internal */
exports.PropertyListings$inboundSchema = z.object({
    rental_listings: z.nullable(z.array(rentallisting_js_1.RentalListing$inboundSchema)),
    sale_listings: z.nullable(z.array(salelisting_js_1.SaleListing$inboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "rental_listings": "rentalListings",
        "sale_listings": "saleListings",
    });
});
/** @internal */
exports.PropertyListings$outboundSchema = z.object({
    rentalListings: z.nullable(z.array(rentallisting_js_1.RentalListing$outboundSchema)),
    saleListings: z.nullable(z.array(salelisting_js_1.SaleListing$outboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        rentalListings: "rental_listings",
        saleListings: "sale_listings",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyListings$;
(function (PropertyListings$) {
    /** @deprecated use `PropertyListings$inboundSchema` instead. */
    PropertyListings$.inboundSchema = exports.PropertyListings$inboundSchema;
    /** @deprecated use `PropertyListings$outboundSchema` instead. */
    PropertyListings$.outboundSchema = exports.PropertyListings$outboundSchema;
})(PropertyListings$ || (exports.PropertyListings$ = PropertyListings$ = {}));
function propertyListingsToJSON(propertyListings) {
    return JSON.stringify(exports.PropertyListings$outboundSchema.parse(propertyListings));
}
function propertyListingsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyListings$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyListings' from JSON`);
}
//# sourceMappingURL=propertylistings.js.map